module.exports = __webpack_public_path__ + "a0c84fb4442afa1e1d05534b9d051b20.pdf";